import { APIClient } from "./axiosClient";

export class ClientApi {
    static getAllClients() {
        return APIClient(
            '/client/getAllClients',
            {},
            { requestType: 'get' }
        );
    }

    static getClientProgramsAndPartners(clientId: number) {
        return APIClient(
            `/client/getClientProgramsAndPartners?clientId=${clientId}`,
            {},
            { requestType: 'get' }
        );
    }

    static getClientsFromDB(params: { id?: string | null; clientId?: string; pageNumber?: number; pageSize?: number; sortOrder?: string; sortBy?: string }) {
        return APIClient(
            '/client/getClientsFromDB',
            params,
            { requestType: 'post' }
        );
    }

    static createClient(params: { 
      clientCode: string; 
      clientName: string; 
      clientAddress: string; 
      clientContactNumber: string; 
      clientEmail: string;
      clientCountry: string; 
      currencyId: number; 
    }) {
        return APIClient(
            '/client/createClient',
            params,
            { requestType: 'post' }
        );
    }

    static getClientById(clientId: string) {
        return APIClient(
            `/client/getClientById?clientId=${clientId}`,
            {},
            { requestType: 'get' }
        );
    }

    static updateClient(clientId: string, params: { 
      clientName: string; 
      clientAddress: string; 
      clientContactNumber: string; 
      clientEmail: string;
      clientCountry: string; 
      currencyId: number; 
    }) {
        return APIClient(
            `/client/updateClient/${clientId}`,
            params,
            { requestType: 'put' }
        );
    }

    static deleteClient(clientId: string) {
        return APIClient(
            `/client/deleteClient/${clientId}`,
            {},
            { requestType: 'delete' }
        );
    }
}